// extracted by mini-css-extract-plugin
export default {"form":"_0aYKV0G1--styles_form__TUstX","button":"_0aYKV0G1--styles_button__uQ00T","wiggle":"_0aYKV0G1--styles_wiggle__aGPlT","shimmer":"_0aYKV0G1--styles_shimmer__bj9uN"};